'use client';

import MobileAdProfiles from '@fe-news/constants/DFP/MobileAdProfiles';
import { styled } from '@linaria/react';
import { DisplayOnMountedAdSlot } from '@fe-news/components/atoms/AdSlot';

const AdSlotBottomContainer = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  z-index: 20;
`;

const MobileBottomAdBanner = () => {
  return (
    <AdSlotBottomContainer>
      <DisplayOnMountedAdSlot
        profile={MobileAdProfiles.dynamicFooterAdPopup}
        close={{ isEnable: true, buttonTop: -20 }}
        isSkeleton={false}
      />
    </AdSlotBottomContainer>
  );
};

export default MobileBottomAdBanner;
